import { render, staticRenderFns } from "./RefreshAppAlert.vue?vue&type=template&id=b2bce8a4&"
import script from "./RefreshAppAlert.vue?vue&type=script&lang=js&"
export * from "./RefreshAppAlert.vue?vue&type=script&lang=js&"
import style0 from "./RefreshAppAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports